// localstorage
const month = 2592000000;

/**
 * 设置value到localstorage
 * @param {string} key 键
 * @param {*} value 值
 */
export function setItem(key, value) {
	window.localStorage.setItem(key, JSON.stringify({ data: value, time: new Date().getTime() }));
}

/**
 * 获取value
 * @param {string} key 键
 * @param {number} exp 过期时间
 * @return {string}
 */
export function getItem(key) {
	if (!key) return '';
	const item = window.localStorage.getItem(key);
	if (!item) return '';
	try {
		var { data } = JSON.parse(item);
	} catch (error) {
		return '';
	}
	return data;
}

/**
 * 获取在有效期内的value
 * @param {string} key 键
 * @param {number} expire 过期时间 默认30天
 * @return {string}
 */
export function getItemUnderExp(key, expire = month) {
	if (!key) return '';
	const item = window.localStorage.getItem(key);
	if (!item) return '';
	try {
		var { data, time } = JSON.parse(item);
	} catch (error) {
		return '';
	}

	let res = '';
	if (new Date().getTime() - parseInt(time) < expire) {
		res = data;
	}
	return res;
}
